import { render, staticRenderFns } from "./ReceivePrintDetails_Vendor.vue?vue&type=template&id=a9887a0c&"
import script from "./ReceivePrintDetails_Vendor.vue?vue&type=script&lang=js&"
export * from "./ReceivePrintDetails_Vendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports